<script setup lang="ts">
const { $get } = useAxios();
const { data: voutings } = await useAsyncData("get all ballots", () =>
  $get("/api/v3/ballot")
);

const route = useRoute();

console.log('voutings', voutings)

useHead({
  title: "РУСДРАМ",
  meta: [
    {
      hid: "title",
      property: "title",
      content: "РУСДРАМ",
    },
    {
      hid: "og:title",
      property: "og:title",
      content: "РУСДРАМ",
    },
    {
      hid: "description",
      name: "description",
      content:
        "Голосования | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "og:description",
      property: "og:description",
      content:
        "Голосования | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "url",
      name: "url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "og:url",
      property: "og:url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "image",
      name: "image",
      content: "https://rusdram.org/rusdram.jpg",
    },
    {
      name: "og:image",
      property: "og:image",
      content: "https://rusdram.org/rusdram.jpg",
    },
  ],
});
</script>

<template>
  <nuxt-layout name="default">
    <r-section>
      <div class="grid grid-cols-1 xl:grid-cols-2 gap-7" v-if="voutings && voutings.length">
        <VouteCard
          v-for="voute in voutings"
          :key="voute._id"
          :voute="voute"
        ></VouteCard>
      </div>
    </r-section>
  </nuxt-layout>
</template>
